import * as z from "zod/v4";

export const deleteAdvancedFlow = {
  name: "deleteAdvancedFlow" as const,
  input: z.object({ flowId: z.string() }),
  output: z.object({ success: z.boolean() }),
};
